import React, { useState, useEffect } from 'react'

import IdletimeTrend from './components/IdleTimeTrend/IdleTimeTrend'
import IdleTimeDoughnut from './components/IdleTimeDoughnut'

import { showNotification } from '../../utils/toast.utils'
import liveDataService from '../../service/liveData.service'
import * as DATE_UTILS from '../../utils/date.utils'

import { useMonthSelectorContext } from '../../context/MonthSelectorContext'

const IdleTimeWrapper = () => {
  const { selectedDate } = useMonthSelectorContext()
  const [isLoading, setIsLoading] = useState(false)
  const [idleTimeData, setIdleTimeData] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)
        const response = await liveDataService.getIdleTimeData({
          currentDate: selectedDate
        })

        if (response.status === 200) {
          setIdleTimeData(response.data.data)
        } else {
          showNotification(response.data.message, 'error')
        }
      } catch (err) {
        console.error('Error fetching idle time data:', err)
        showNotification('Failed to load idle time data', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [selectedDate])

  if (isLoading) return <div>Loading...</div>
  if (!idleTimeData) return <div>No data available</div>

  return (
    <>
      {idleTimeData.idleTimeTrend && (
        <IdletimeTrend idleTimeTrendData={idleTimeData.idleTimeTrend} />
      )}
      {idleTimeData.idleTimeReasonData && (
        <IdleTimeDoughnut idleTimeData={idleTimeData.idleTimeReasonData} />
      )}
    </>
  )
}

export default IdleTimeWrapper
